import React, { useEffect, useState } from 'react';

import { API_URL } from '../../constants/api';
import { decodeFullToken, decodeToken, getToken } from '../../utils/TokenUtils';
import { CURRENT_DATE, CURRENT_TIME } from '../../constants';
import '../../css/smallTable.css';
const ActivityReport = ({
  sections,
  link,
  reportHeader = {},
  reportFooter = {},
}) => {
  const formatLabel = (str) =>
    str.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase());

  const storedData = localStorage.getItem('printData');
  const linkData = localStorage.getItem('linkData');
  const reportHeaderData = localStorage.getItem('reportHeader');
  // console.log('reportHeaderData:', reportHeaderData);
  let parsedData = {};
  let linkParsedData = {};
  let reportHeaderParsedData = {};

  if (storedData) {
    parsedData = JSON.parse(storedData);
  }

  if (linkData) {
    linkParsedData = JSON.parse(linkData);
  }

  if (reportHeaderData && reportHeaderData !== 'undefined') {
    try {
      reportHeaderParsedData = JSON.parse(reportHeaderData);
    } catch (e) {
      console.error('Invalid JSON in reportHeader:', reportHeaderData);
    }
  }

  if (!sections && !link) {
    sections = parsedData;
    link = linkParsedData;
    reportHeader = reportHeaderParsedData;
  }
  // console.log('sections:', sections);
  // console.log('reportHeader par:', reportHeader);

  const renderFields = (fields) => (
    <div style={{ marginBottom: '20px' }}>
      <table className="table table-bordered">
        <tbody>
          {Object.entries(fields).map(([key, value]) => (
            <tr key={key}>
              {' '}
              <th>{formatLabel(key)}:</th> <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderTable = (rows, title) => {
    if (!rows.length) return null;

    const allKeys = Object.keys(rows[0]);

    const hasFooterKey = allKeys.includes('has_footer');
    const groupKey = allKeys.find((k) => k.endsWith('~group'));
    const spanKeys = allKeys.filter((k) => k.endsWith('~span'));
    // console.log('spanKeys:', spanKeys);
    const visibleKeys = allKeys.filter(
      (k) =>
        !k.endsWith('~group') &&
        k !== 'has_footer' &&
        !k.includes('~hide') &&
        k !== 'color'
    );
    const getCleanKey = (key) => key.split('~')[0];

    // console.log('visibleKeys:', visibleKeys);

    const groupedRows = groupKey
      ? rows.reduce((acc, row) => {
          const groupValue = row[groupKey];
          if (!acc[groupValue]) acc[groupValue] = [];
          acc[groupValue].push(row);
          return acc;
        }, {})
      : { Default: rows };
    // console.log('groupedRows:', groupedRows);
    return (
      <div className="">
        {Object.entries(groupedRows).map(
          ([groupValue, groupRows], groupIdx) => {
            // Separate footer if exists
            const isFooter =
              hasFooterKey && groupRows[groupRows.length - 1]?.has_footer;
            const dataRows = isFooter ? groupRows.slice(0, -1) : groupRows;
            const footerRow = isFooter ? groupRows[groupRows.length - 1] : null;

            // Prepare span map
            const spanCountMap = {};
            spanKeys.forEach((spanKey) => {
              spanCountMap[spanKey] = {};
              let prev = null;
              dataRows.forEach((row, i) => {
                const val = row[spanKey];
                if (val === prev) {
                  spanCountMap[spanKey][i] = 0;
                  spanCountMap[spanKey][i - 1] =
                    (spanCountMap[spanKey][i - 1] || 1) + 1;
                } else {
                  spanCountMap[spanKey][i] = 1;
                }
                prev = val;
              });
            });
            // console.log('spanCountMap:', spanCountMap);
            return (
              <div key={groupIdx} className="">
                {groupKey && (
                  <h5 className="mb-2">
                    {getCleanKey(groupKey)}: {groupValue}
                  </h5>
                )}
                {/* <table className="table table-bordered"> */}
                <table className="small-table">
                  <thead>
                    <tr>
                      {visibleKeys.map((key) => (
                        <th key={key}>{formatLabel(getCleanKey(key))}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {/* {dataRows.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {visibleKeys.map((key, colIndex) => {
                          const value = row[key];

                          // Handle span columns
                          if (spanKeys.includes(key)) {
                            // If same as previous row → skip
                            if (
                              rowIndex > 0 &&
                              row[key] === dataRows[rowIndex - 1][key]
                            ) {
                              return null;
                            }

                            // Count how many rows forward have the same value
                            let span = 1;
                            for (
                              let i = rowIndex + 1;
                              i < dataRows.length;
                              i++
                            ) {
                              if (dataRows[i][key] === value) {
                                span++;
                              } else {
                                break;
                              }
                            }

                            return (
                              <td
                                key={colIndex}
                                rowSpan={span}
                                dangerouslySetInnerHTML={{ __html: value }}
                              />
                            );
                          }

                          // Normal columns
                          return (
                            <td
                              key={colIndex}
                              dangerouslySetInnerHTML={{ __html: value }}
                            />
                          );
                        })}
                      </tr>
                    ))} */}
                    {dataRows.map((row, rowIndex) => {
                      // Check if this row is the "first occurrence" of a span group
                      const isFirstInGroup =
                        rowIndex === 0 ||
                        !spanKeys.every(
                          (key) => row[key] === dataRows[rowIndex - 1][key]
                        );

                      // Calculate rowspan length (only for the first in a group)
                      let spanLength = 1;
                      if (isFirstInGroup) {
                        for (let i = rowIndex + 1; i < dataRows.length; i++) {
                          if (
                            spanKeys.every(
                              (key) => row[key] === dataRows[i][key]
                            )
                          ) {
                            spanLength++;
                          } else {
                            break;
                          }
                        }
                      }

                      return (
                        <tr
                          key={rowIndex}
                          style={
                            row.color
                              ? { backgroundColor: row.color, color: 'white' }
                              : undefined
                          }
                        >
                          {visibleKeys.map((key, colIndex) => {
                            const value = row[key];

                            if (spanKeys.includes(key)) {
                              // Only render for the first row in group
                              if (isFirstInGroup) {
                                return (
                                  <td
                                    key={colIndex}
                                    rowSpan={spanLength}
                                    dangerouslySetInnerHTML={{ __html: value }}
                                  />
                                );
                              } else {
                                return null; // skip inside group
                              }
                            }

                            // Clean the key and value
                            const cleanKey = getCleanKey(key);
                            let min = 50; //key?.split('~')[1].split(':')[1];
                            let color = 'red'; // key?.split('~')[1].split(':')[0];
                            const cell_color = key?.split('~')[1];
                            if (key.includes('~')) {
                              color = cell_color.split(':')[1];

                              min = cell_color.split(':')[2];
                              // console.log(
                              //   'key:',
                              //   key,
                              //   'cell_color:',
                              //   cell_color,
                              //   'min:',
                              //   min,
                              //   'color:',
                              //   color
                              // );
                            }

                            const cleanValue = String(value).replace(
                              /[^0-9.]/g,
                              ''
                            ); // remove % or non-numeric chars

                            // Exclude non-course columns
                            const nonCourseColumns = ['ID', 'TOTAL', 'AVERAGE'];

                            const cellStyle = {};

                            // Only highlight dynamic course columns if value < 50

                            if (
                              key.includes('cell-color') &&
                              parseFloat(cleanValue) < min
                            ) {
                              cellStyle.color = color;
                            }

                            // Preserve existing row background color if any
                            if (row.color) {
                              cellStyle.backgroundColor = row.color;
                            }

                            return (
                              <td
                                key={colIndex}
                                style={cellStyle}
                                dangerouslySetInnerHTML={{ __html: value }}
                              />
                            );
                            // Only highlight dynamic course columns if value < 50
                            if (
                              !nonCourseColumns.includes(cleanKey) &&
                              parseFloat(cleanValue) < 50
                            ) {
                              cellStyle.color = 'red';
                            }

                            // Preserve existing row background color if any
                            if (row.color) {
                              cellStyle.backgroundColor = row.color;
                            }

                            return (
                              <td
                                key={colIndex}
                                style={cellStyle}
                                dangerouslySetInnerHTML={{ __html: value }}
                              />
                            );
                          })}
                        </tr>
                      );
                    })}

                    {footerRow && (
                      <tr style={{ fontWeight: 'bold' }}>
                        {visibleKeys.map((key, colIndex) => (
                          <td key={colIndex}>{footerRow[key]}</td>
                        ))}
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            );
          }
        )}
      </div>
    );
  };
  const renderGrid = (fields, title) => {
    const entries = Object.entries(fields);

    return (
      <div className="container">
        <div className="row">
          {entries.map(([key, value], index) => (
            <div className="col-6" key={index}>
              <strong>{formatLabel(key)}:</strong> {value}
            </div>
          ))}
        </div>
      </div>
    );
  };

  if (!sections.length) return <p>Loading...</p>;
  // console.log('sections:', sections);
  const styles = {
    td: {
      size: '8px',
      padding: '0px',
    },
    div: {
      size: '8px',
      padding: '0px',
      margin: '0px',
    },

    printPage: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      border: '1px solid black',
    },
    cell: {
      border: '1px solid black',
      textAlign: 'left',
    },
    header: {
      textAlign: 'center',
      marginBottom: '0px',
    },
    logo: {
      width: '95%',
      height: '150px',
    },
  };

  const token = getToken();

  const decoded = decodeFullToken(token);

  // console.log('decoded:', decoded);
  return (
    <div style={{ padding: '5px', maxWidth: '98%', margin: '0 auto' }}>
      <header style={styles.header}>
        <img
          src={`${API_URL}/${decoded?.banner}`}
          alt="Company Banner"
          style={styles.logo}
        />
      </header>
      {reportHeader && reportHeader?.length == 0 && (
        <h2 style={{ textAlign: 'center', margin: '0px' }}>
          {link?.page_title}
        </h2>
      )}
      <div
        style={{ textAlign: 'right', marginTop: '0px', marginBottom: '0px' }}
      >
        Printed:{' '}
        <strong>
          {CURRENT_DATE} {CURRENT_TIME}
        </strong>
      </div>
      <p>{link?.description}</p>

      <div className="container mt-4">
        {reportHeader &&
          reportHeader.length > 0 &&
          reportHeader?.map((item, index) => (
            <div key={index} className="row mb-3">
              {Object.entries(item).map(([key, value], i) => {
                const Tag = key; // e.g. 'h1', 'h2', 'div', etc.

                return (
                  <Tag key={i} className="mb-2 text-center">
                    <strong>{value}</strong>
                  </Tag>
                );
              })}
            </div>
          ))}
      </div>

      <div className="row">
        {sections.map((section, index) => (
          <>
            <div key={index} className={`col-${section.grid}`}>
              {section.title && (
                <h4 dangerouslySetInnerHTML={{ __html: section.title }} />
              )}{' '}
              {section.fields &&
                (section.grid === 20
                  ? renderGrid(section.fields, section.title)
                  : renderFields(section.fields, section.title))}
              {section.table && renderTable(section.table, section.title)}
            </div>
            {section.space !== '' && (
              <div className={`col-${section.space}`}></div>
            )}
          </>
        ))}
      </div>
      <footer
        style={{ marginTop: '40px', fontSize: '14px', textAlign: 'center' }}
      >
        <div style={{ marginBottom: '20px' }}>
          <div></div>
          <strong>{decoded.name}</strong>
          <br />
          <span>{decoded.user_title}</span>
          <br />
          <p>_____________________________________</p>
          <br />
          <br />
        </div>

        <div>
          <strong>Address:</strong> {decoded?.companyAddress} &nbsp; | &nbsp;
          <strong>Email:</strong> {decoded?.companyEmail}
        </div>
      </footer>
      <br />
      <br />
      <br />
    </div>
  );
};

export default ActivityReport;
